import React from 'react';

export const LeftArrow = () => (
  <svg width="15" height="21" viewBox="0 0 15 21">
    <path d="M10.078 18.326h.012c-.293.354-.684.549-1.172.549-.415 0-.781-.159-1.111-.464l-6.714-6.726c-1.257-1.257-1.257-3.198 0-4.456l6.641-6.641c.574-.562 1.392-.696 2.026-.232.781.537.879 1.721.244 2.344l-6.726 6.799 6.641 6.641c.635.635.696 1.563.159 2.185z" />
  </svg>
);
